import styled, { css } from 'styled-components';

export const Title03TextContainer = styled.div`
    font-family: "museo sans";
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;

    ${props => css`
        color: ${props.color}
    `}




`;